import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=fe97f750&scoped=true"
import script from "./Purchased.vue?vue&type=script&lang=js"
export * from "./Purchased.vue?vue&type=script&lang=js"
import style0 from "./Purchased.vue?vue&type=style&index=0&id=fe97f750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe97f750",
  null
  
)

export default component.exports